<template>
  <main>
    <div class="holder">
      <back-button />

      <section id="partner" ref="cont">
        <div class="info">
          <div
            class="logo-holder"
            :style="'background-color: ' + partner.color"
          >
            <img
              :src="createResourceUrl(partner.logoResourceId)"
              :alt="partner.title"
              :title="partner.title"
            />
          </div>

          <div class="title">
            <strong>{{ partner.title }}</strong
            >{{ partner.categoryName }}
          </div>
        </div>
        <div id="photos" v-if="partner.resourceIds.length > 0">
          <ul
            :class="{ 'js-slider': partner.resourceIds.length > 1 }"
            data-arrows="true"
            v-if="partner.resourceIds.length > 0"
          >
            <li v-for="(item, index) in partner.resourceIds" :key="index">
              <a
                class="js-lightbox"
                data-gallery="photos"
                :href="createResourceUrl(item)"
              >
                <img
                  :src="createResourceUrl(item)"
                  alt="#"
                  title="#"
                  v-if="item"
                />
              </a>
              <span
                :style="
                  'background-image: url(' +
                    url +
                    'api/client/resource/' +
                    item +
                    ')'
                "
              ></span>
            </li>
          </ul>
          <div class="count">{{ partner.resourceIds.length }}</div>
        </div>
        <div
          v-if="partner.description"
          class="text"
          style="white-space: pre-wrap;"
        >
          <p>{{ partner.description }}</p>
        </div>
        <div
          v-else-if="partner.title"
          class="text"
          style="white-space: pre-wrap; text-align: center;"
        >
          <loading-progress
            :progress="0"
            :indeterminate="true"
            :counter-clockwise="false"
            :hide-background="false"
            shape="circle"
            :size="loadingIconSize"
          />
        </div>

        <div class="tools">
          <ul>
            <li>
              <span
                v-if="isAuthenticated"
                class="selected"
                :class="{ act: partner.favorite }"
                @click="addItemToFavorite"
              ></span>
            </li>
          </ul>
        </div>
        <div id="contacts-data">
          <ul>
            <li v-if="hasVK">
              <a :href="getVK">
                <svg
                  width="22"
                  height="14"
                  viewBox="0 0 22 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.4952 0.947987C21.6481 0.401536 21.4952 0 20.7673 0H18.3605C17.7486 0 17.4664 0.346868 17.3134 0.729362C17.3134 0.729362 16.0895 3.92607 14.3556 6.00254C13.7946 6.60361 13.5396 6.79486 13.2336 6.79486C13.0807 6.79486 12.8592 6.60361 12.8592 6.0572V0.94799C12.8592 0.292247 12.6816 0 12.1716 0H8.38945C8.00703 0 7.77703 0.304346 7.77703 0.592784C7.77703 1.21441 8.64393 1.35777 8.73328 3.10641V6.90419C8.73328 7.73684 8.59295 7.8878 8.28696 7.8878C7.47104 7.8878 5.48632 4.67682 4.30919 1.00261C4.0785 0.288474 3.84712 0 3.23201 0H0.825199C0.137539 0 0 0.346868 0 0.729362C0 1.41244 0.815961 4.80039 3.79925 9.2812C5.7881 12.3412 8.59025 14 11.1401 14C12.67 14 12.8592 13.6316 12.8592 12.997V10.6842C12.8592 9.94737 13.0042 9.80032 13.4886 9.80032C13.8456 9.80032 14.4576 9.99156 15.8855 11.467C17.5174 13.2156 17.7864 14 18.7043 14H21.1112C21.7988 14 22.1426 13.6316 21.9443 12.9045C21.7272 12.1799 20.9481 11.1286 19.9143 9.88227C19.3533 9.17191 18.5118 8.40692 18.2568 8.02434C17.8999 7.5326 18.0019 7.31397 18.2568 6.87686C18.2568 6.87686 21.1892 2.45067 21.4952 0.947987Z"
                    fill="#BEBAB5"
                  />
                </svg>
              </a>
            </li>
            <li v-if="hasTG">
              <a :href="getTG">
                <svg
                  width="21"
                  height="17"
                  viewBox="0 0 21 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.977816 7.01823L19.6014 0.0848573C20.4658 -0.216661 21.2207 0.288461 20.9406 1.55049L20.9422 1.54893L17.7712 15.9737C17.5362 16.9963 16.9069 17.245 16.0264 16.7632L11.1974 13.3268L8.86829 15.4934C8.61075 15.7421 8.39345 15.9519 7.89446 15.9519L8.23731 11.2069L17.1869 3.40001C17.5765 3.06896 17.1 2.88246 16.5865 3.21195L5.52667 9.93551L0.758904 8.49941C-0.276097 8.18235 -0.298632 7.50004 0.977816 7.01823Z"
                    fill="#BEBAB5"
                  />
                </svg>
              </a>
            </li>
            <li v-if="hasEmail">
              <a :href="getEmail">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    class="stroked"
                    d="M1.83398 17.875H20.1673V11V4.125H11.0007H1.83398V11V17.875Z"
                    fill="#BEBAB5"
                    stroke="#BEBAB5"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.83398 4.125L11.0007 11L20.1673 4.125"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    class="stroked"
                    d="M4.0007 4.125H1.83398V11"
                    stroke="#BEBAB5"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    class="stroked"
                    d="M20.1667 11V4.125H19"
                    stroke="#BEBAB5"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </li>
            <li v-if="hasPhone">
              <a :href="getPhone">
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    class="stroked"
                    d="M4.85469 1.45068C5.18087 1.45068 5.48142 1.62759 5.63978 1.9128L6.73816 3.89137C6.88197 4.15043 6.88875 4.46377 6.75621 4.7288L5.69805 6.84516C5.69805 6.84516 6.00471 8.42171 7.28807 9.70507C8.57148 10.9884 10.1427 11.2898 10.1427 11.2898L12.2587 10.2318C12.5239 10.0992 12.8375 10.1061 13.0967 10.2501L15.0808 11.3533C15.3658 11.5117 15.5425 11.8121 15.5425 12.1381V14.416C15.5425 15.576 14.465 16.4139 13.3659 16.043C11.1084 15.2813 7.60424 13.831 5.38323 11.6099C3.16222 9.3889 1.71189 5.88475 0.950179 3.62732C0.579313 2.52818 1.41715 1.45068 2.57715 1.45068H4.85469Z"
                    fill="#BEBAB5"
                    stroke="#BEBAB5"
                    stroke-width="0.96"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </li>
            <li v-if="hasWeb">
              <a :href="getWeb">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.824311 7.45843C0.933454 7.06417 1.06487 6.67882 1.22079 6.30015C1.20965 6.32688 1.19852 6.35361 1.18515 6.38256L1.25197 6.22219C1.24084 6.24669 1.23193 6.26896 1.22302 6.29347C1.41457 5.85469 1.63508 5.42922 1.88455 5.0216C2.01819 4.80554 2.15852 4.59393 2.30553 4.38902C2.3434 4.33779 2.37904 4.28656 2.41913 4.23533C2.4325 4.21751 2.44364 4.20192 2.457 4.1841C2.53273 4.08832 2.60847 3.99477 2.68642 3.90122C3.01163 3.51588 3.368 3.15281 3.74666 2.82094C3.84244 2.7363 3.93822 2.65611 4.03623 2.57593C4.083 2.53806 4.13201 2.49797 4.18101 2.4601C4.16765 2.47124 4.15428 2.48015 4.14092 2.48906C4.14092 2.48906 4.13869 2.48906 4.13869 2.49129C4.14983 2.48015 4.20328 2.44006 4.21219 2.4356C4.20997 2.43783 4.20106 2.44451 4.18324 2.45787C4.1966 2.44896 4.20774 2.43783 4.2211 2.42892C4.4238 2.27745 4.63093 2.13267 4.84476 1.99457C5.30582 1.69833 5.79364 1.43996 6.29702 1.22164C6.27029 1.23278 6.24579 1.24392 6.21906 1.25506L6.37943 1.18823C6.35271 1.19937 6.32598 1.21051 6.29925 1.22165C6.67568 1.06796 7.06102 0.936536 7.4508 0.827393C6.94518 1.5758 6.59991 2.45117 6.32821 3.28646C6.06982 4.08611 5.87382 4.90579 5.72903 5.7366C5.10313 5.84574 4.48392 5.98384 3.87358 6.15315C3.06949 6.37811 2.27652 6.66545 1.53255 7.04411C1.29422 7.16885 1.05365 7.30694 0.824219 7.45841L0.824311 7.45843Z"
                    fill="#BEBAB5"
                  />
                  <path
                    d="M7.46193 19.1836C7.06545 19.0745 6.67788 18.9408 6.29698 18.7849C6.32371 18.796 6.35044 18.8072 6.37939 18.8206L6.21902 18.7537C6.24352 18.7649 6.26802 18.7738 6.29029 18.7827C5.85151 18.5911 5.42605 18.3706 5.01842 18.1212C4.80236 17.9875 4.59076 17.8472 4.38585 17.7002C4.33462 17.6623 4.28339 17.6267 4.23216 17.5888C4.21434 17.5754 4.19875 17.5621 4.18093 17.5509C4.08515 17.4752 3.9916 17.3995 3.90028 17.3215C3.51493 16.9963 3.15186 16.6399 2.82 16.2613C2.73536 16.1655 2.65517 16.0697 2.57498 15.9717C2.53712 15.9249 2.49702 15.8759 2.45916 15.8269C2.47029 15.8403 2.4792 15.8537 2.48811 15.867C2.47697 15.8537 2.43688 15.8024 2.43243 15.7957C2.43465 15.798 2.44134 15.8069 2.4547 15.8247C2.44579 15.8113 2.43465 15.798 2.42574 15.7868C2.27428 15.5841 2.1295 15.377 1.9914 15.1632C1.69516 14.7021 1.43678 14.2143 1.21847 13.7109C1.22961 13.7376 1.24074 13.7621 1.25188 13.7889L1.18506 13.6285C1.1962 13.6552 1.20734 13.682 1.21847 13.7087C1.06478 13.3323 0.933363 12.9469 0.824219 12.5571C1.57263 13.0627 2.448 13.408 3.28328 13.6775C4.08293 13.9359 4.90482 14.1319 5.73791 14.2767C5.80919 14.6888 5.89383 15.0986 5.98961 15.504C6.1923 16.3593 6.46403 17.1924 6.81821 17.9965C7.00086 18.4085 7.21247 18.8095 7.46195 19.1837L7.46193 19.1836Z"
                    fill="#BEBAB5"
                  />
                  <path
                    d="M12.5469 0.827513C12.9411 0.936657 13.3265 1.06807 13.7051 1.22399C13.6784 1.21286 13.6517 1.20172 13.6227 1.18836L13.7831 1.25518C13.7586 1.24404 13.7341 1.23513 13.7118 1.22622C14.1506 1.41778 14.5761 1.63828 14.9837 1.88775C15.1998 2.0214 15.4114 2.16173 15.6163 2.30874C15.6675 2.3466 15.7187 2.38224 15.77 2.42011C15.7878 2.43347 15.8034 2.44684 15.8212 2.45798C15.917 2.53371 16.0105 2.60944 16.1019 2.6874C16.4872 3.0126 16.8503 3.36897 17.1821 3.74764C17.2668 3.84342 17.347 3.93919 17.4271 4.0372C17.465 4.08398 17.5051 4.13298 17.543 4.18198C17.5318 4.16862 17.5229 4.15526 17.514 4.14189C17.514 4.14189 17.514 4.13966 17.5118 4.13966C17.5229 4.1508 17.563 4.20426 17.5675 4.21317C17.5652 4.21094 17.5586 4.20203 17.5452 4.18421C17.5541 4.19758 17.5652 4.21094 17.5742 4.22208C17.7256 4.42478 17.8704 4.6319 18.0085 4.84573C18.3047 5.3068 18.5631 5.79462 18.7814 6.298C18.7703 6.27127 18.7592 6.24677 18.748 6.22004C18.7703 6.27349 18.7926 6.32695 18.8148 6.38041C18.8037 6.35368 18.7926 6.32695 18.7814 6.30022C18.9373 6.67888 19.0688 7.06643 19.1779 7.4607C18.5921 7.06422 17.9328 6.77244 17.2735 6.52517C16.3045 6.15987 15.2933 5.9082 14.2665 5.7322C14.1573 5.10631 14.0192 4.48709 13.8499 3.87676C13.6249 3.07267 13.3376 2.2797 12.959 1.53573C12.8364 1.29739 12.6983 1.05682 12.5469 0.827393L12.5469 0.827513Z"
                    fill="#BEBAB5"
                  />
                  <path
                    d="M19.1803 12.5435C19.0712 12.9399 18.9375 13.3275 18.7816 13.7084C18.7928 13.6817 18.8039 13.655 18.8173 13.626L18.7504 13.7864C18.7616 13.7619 18.7705 13.7374 18.7794 13.7151C18.5878 14.1539 18.3673 14.5793 18.1179 14.987C17.9842 15.203 17.8439 15.4146 17.6969 15.6195C17.659 15.6708 17.6234 15.722 17.5833 15.7732C17.5699 15.7911 17.5588 15.8066 17.5454 15.8245C17.4697 15.9202 17.3939 16.0138 17.316 16.1073C16.9908 16.4927 16.6344 16.8558 16.2558 17.1876C16.16 17.2723 16.0642 17.3525 15.9662 17.4326C15.9194 17.4705 15.8704 17.5106 15.8214 17.5485C15.8348 17.5396 15.8481 17.5284 15.8615 17.5195H15.8637C15.8504 17.5306 15.7991 17.5707 15.7924 17.5752C15.7947 17.573 15.8036 17.5663 15.8214 17.5529C15.808 17.5618 15.7969 17.573 15.7835 17.5819C15.5808 17.7333 15.3737 17.8781 15.1599 18.0162C14.6988 18.3125 14.211 18.5708 13.7076 18.7891C13.7343 18.778 13.7589 18.7669 13.7856 18.7557C13.7321 18.778 13.6787 18.8003 13.6252 18.8226C13.6519 18.8114 13.6787 18.8003 13.7054 18.7891C13.3267 18.9451 12.9392 19.0765 12.5449 19.1856C12.9414 18.5998 13.2332 17.9405 13.4804 17.2812C13.8457 16.3123 14.0997 15.2988 14.2734 14.2697C14.6855 14.1984 15.0953 14.1138 15.5007 14.018C16.3561 13.8153 17.1891 13.5436 17.9932 13.1894C18.4053 13.0045 18.8062 12.7929 19.1804 12.5435H19.1803Z"
                    fill="#BEBAB5"
                  />
                  <path
                    d="M10 5.39384C9.04671 5.39384 8.08447 5.43839 7.12891 5.54308C7.267 4.84143 7.4452 4.14649 7.67461 3.46712C7.75702 3.22433 7.84611 2.98378 7.94412 2.74767C7.93298 2.7744 7.91962 2.80113 7.90848 2.83008C7.93076 2.77662 7.95303 2.72316 7.9753 2.66971C7.96417 2.69421 7.95526 2.71871 7.94412 2.74321C8.129 2.31555 8.34283 1.8968 8.60346 1.50922C8.63464 1.46467 8.6636 1.42012 8.69478 1.37558C8.71037 1.3533 8.72596 1.33325 8.74155 1.31098C8.74155 1.31098 8.74378 1.30876 8.74378 1.30653C8.73042 1.32435 8.71928 1.33771 8.71705 1.33994C8.71928 1.33771 8.72819 1.32658 8.75046 1.29762C8.7616 1.28425 8.76828 1.27312 8.77497 1.26643C8.76606 1.27757 8.75715 1.29094 8.74824 1.30207C8.76828 1.27757 8.79056 1.25084 8.79947 1.23748C8.83288 1.19738 8.86629 1.15729 8.90193 1.1172C8.96652 1.04369 9.03557 0.974645 9.10462 0.905596C9.16476 0.847682 9.24272 0.796452 9.30064 0.736314C9.30286 0.734087 9.30732 0.731859 9.30955 0.729632C9.34964 0.702903 9.38751 0.676174 9.42982 0.651671C9.48774 0.616032 9.54788 0.58485 9.61025 0.553667C9.69711 0.522483 9.78398 0.497981 9.87531 0.480162C9.84635 0.482389 9.81739 0.484617 9.78844 0.489071C9.81962 0.484616 9.84858 0.480162 9.87976 0.477934C9.90872 0.473479 9.93768 0.471252 9.96663 0.466797C9.94213 0.471252 9.91986 0.473479 9.89535 0.477934H9.97777H10.0156H10.098C10.0758 0.473479 10.0513 0.469024 10.0268 0.466797C10.0557 0.471252 10.0847 0.473479 10.1136 0.477934C10.1448 0.482389 10.1738 0.486844 10.205 0.489071C10.176 0.484616 10.147 0.482389 10.1181 0.480162C10.2072 0.497981 10.2963 0.522484 10.3809 0.553667C10.5034 0.611581 10.6193 0.682858 10.7284 0.760815C10.764 0.789771 10.7975 0.818728 10.8309 0.849911C10.9021 0.914505 10.9712 0.98133 11.0358 1.05261C11.1048 1.12611 11.1694 1.20185 11.2318 1.2798C11.2273 1.27312 11.2229 1.26644 11.2184 1.26198C11.2251 1.26867 11.2296 1.27758 11.2362 1.28426V1.28648V1.28871C11.2496 1.3043 11.2763 1.32881 11.2808 1.34663C11.2808 1.35108 11.2674 1.33326 11.2518 1.31099C11.2808 1.34885 11.3075 1.38895 11.3365 1.42904C11.4701 1.6206 11.5926 1.82106 11.704 2.02598C11.831 2.25985 11.9468 2.50264 12.0537 2.74767C12.0426 2.72094 12.0314 2.69198 12.0203 2.66526C12.0426 2.71871 12.0648 2.77217 12.0871 2.82563C12.0782 2.80335 12.0693 2.78108 12.0582 2.75881C12.4257 3.65201 12.6796 4.59198 12.8667 5.53862C12.4368 5.49185 12.0092 5.46066 11.5815 5.43393C11.058 5.4072 10.5302 5.39384 10 5.39384L10 5.39384Z"
                    fill="#BEBAB5"
                  />
                  <path
                    d="M12.3249 16.542C12.2425 16.7848 12.1534 17.0253 12.0554 17.2615C12.0666 17.2347 12.0799 17.2058 12.0911 17.179C12.0688 17.2325 12.0465 17.286 12.0242 17.3394C12.0354 17.3149 12.0443 17.2904 12.0554 17.2659C11.8705 17.6936 11.6567 18.1123 11.3961 18.4999C11.3649 18.5445 11.3359 18.589 11.3048 18.6335C11.2892 18.6558 11.2736 18.6759 11.258 18.6981C11.2691 18.6848 11.278 18.6736 11.2803 18.6692C11.2758 18.6736 11.2669 18.687 11.2491 18.7093C11.2379 18.7226 11.2313 18.7316 11.2246 18.7405C11.2335 18.7293 11.2424 18.716 11.2513 18.7048C11.2313 18.7293 11.209 18.7561 11.2001 18.7694C11.1667 18.8095 11.1333 18.8496 11.0976 18.8897C11.033 18.9632 10.964 19.0323 10.8949 19.1013C10.8348 19.1592 10.7568 19.2082 10.6989 19.2706C10.6967 19.2728 10.6922 19.275 10.69 19.2773C10.6499 19.304 10.612 19.3307 10.5697 19.3552C10.5118 19.3909 10.4517 19.422 10.3893 19.451C10.3024 19.4822 10.2156 19.5067 10.1242 19.5245C10.1532 19.5223 10.1822 19.5201 10.2111 19.5156C10.1799 19.5201 10.151 19.5245 10.1198 19.5267H10.1042H10.0218H9.98391H9.9015H9.88591C9.85472 19.5223 9.82576 19.5178 9.79458 19.5156C9.82354 19.5201 9.8525 19.5223 9.88145 19.5245C9.79235 19.5067 9.70326 19.4822 9.61862 19.451C9.49611 19.3931 9.38028 19.3218 9.27114 19.2439C9.2355 19.2149 9.20209 19.1859 9.16868 19.1548C9.0974 19.0902 9.02836 19.0211 8.96376 18.9521C8.89471 18.8786 8.83012 18.8028 8.76775 18.7249V18.7226L8.76552 18.7204V18.7182V18.716C8.75216 18.7026 8.72543 18.6759 8.72097 18.658C8.72097 18.6536 8.73434 18.6714 8.74993 18.6937C8.72097 18.6558 8.69424 18.6157 8.66529 18.5756C8.53165 18.3841 8.40913 18.1836 8.29777 17.9787C8.1708 17.7448 8.05498 17.502 7.94806 17.257C7.9592 17.2837 7.97034 17.3127 7.98147 17.3394C7.96366 17.2971 7.94584 17.2548 7.92802 17.2125C7.93247 17.2236 7.93693 17.2347 7.94138 17.2459C7.57386 16.3527 7.31993 15.4149 7.13281 14.4683C7.82331 14.5418 8.5138 14.5863 9.20209 14.6064C10.4227 14.6443 11.6545 14.6019 12.8751 14.4661C12.7326 15.1699 12.5544 15.8649 12.3249 16.542L12.3249 16.542Z"
                    fill="#BEBAB5"
                  />
                  <path
                    d="M5.53639 12.8755C4.83474 12.7374 4.13981 12.5593 3.46267 12.3298C3.21988 12.2474 2.97933 12.1583 2.74322 12.0603C2.76995 12.0715 2.7989 12.0848 2.82563 12.096C2.77217 12.0737 2.71872 12.0514 2.66526 12.0291C2.68976 12.0403 2.71426 12.0492 2.73876 12.0603C2.3111 11.8755 1.89236 11.6616 1.50477 11.401C1.46022 11.3698 1.41568 11.3409 1.37335 11.3097C1.35108 11.2941 1.33103 11.2785 1.30876 11.2629C1.30653 11.2629 1.30653 11.2607 1.3043 11.2607C1.3199 11.274 1.33549 11.2852 1.33772 11.2874C1.33549 11.2852 1.32212 11.2763 1.29539 11.2562C1.28203 11.2451 1.27312 11.2384 1.26421 11.2317C1.27535 11.2406 1.28871 11.2495 1.29985 11.2584C1.27535 11.2406 1.24862 11.2183 1.23525 11.2072C1.19516 11.1738 1.15507 11.1404 1.11498 11.1048C1.04147 11.0402 0.972421 10.9711 0.903371 10.8998C0.845458 10.8397 0.794228 10.7617 0.73409 10.7038C0.731862 10.7016 0.729635 10.6971 0.727408 10.6949C0.700679 10.6548 0.67395 10.6169 0.649447 10.5746C0.613808 10.5167 0.582626 10.4566 0.553667 10.3942C0.522483 10.3073 0.495753 10.2205 0.480161 10.1291C0.482389 10.1581 0.484616 10.1871 0.489071 10.216C0.484616 10.1848 0.480161 10.1559 0.477934 10.1247C0.473479 10.0957 0.471252 10.0668 0.466797 10.0378C0.471252 10.0623 0.473479 10.0846 0.477934 10.1091V10.0267V9.98882V9.90641C0.473479 9.92868 0.469024 9.95318 0.466797 9.97769C0.471252 9.94873 0.475706 9.91977 0.477934 9.89082C0.482389 9.85963 0.486843 9.83068 0.489071 9.79949C0.484616 9.82845 0.482389 9.85741 0.480161 9.88636C0.497981 9.79727 0.522484 9.70817 0.553667 9.62353C0.61158 9.50102 0.682858 9.38519 0.760814 9.27605C0.789771 9.24042 0.818728 9.207 0.849911 9.17359C0.914504 9.10232 0.983554 9.03327 1.05261 8.96867C1.12611 8.89962 1.20185 8.83503 1.2798 8.77266C1.27312 8.77712 1.26644 8.78157 1.26198 8.78603C1.26866 8.77934 1.27757 8.77489 1.28426 8.76821H1.28648L1.28871 8.76598C1.3043 8.75262 1.32881 8.72589 1.34663 8.72143C1.35108 8.72143 1.33326 8.73479 1.31099 8.75039C1.34885 8.72143 1.38895 8.69247 1.42904 8.66574C1.62059 8.5321 1.82106 8.40959 2.02821 8.29822C2.26209 8.17126 2.50488 8.05544 2.74991 7.94852C2.72318 7.95966 2.69422 7.97079 2.66749 7.98193L2.82787 7.91511C2.80559 7.92402 2.78332 7.93293 2.76105 7.94407C3.65425 7.57655 4.59198 7.32261 5.53862 7.1355C5.46511 7.82599 5.42057 8.51648 5.40052 9.20478C5.36043 10.4232 5.40052 11.6549 5.53639 12.8756L5.53639 12.8755Z"
                    fill="#BEBAB5"
                  />
                  <path
                    d="M13.2786 10.0045C13.2786 11.038 13.2185 12.0715 13.0938 13.0984C11.4321 13.3033 9.74818 13.3367 8.07748 13.2142C7.68546 13.1853 7.29568 13.1474 6.90585 13.0984C6.70093 11.4367 6.66751 9.7528 6.79002 8.0821C6.81898 7.69007 6.85684 7.30029 6.90585 6.91046C7.93269 6.7835 8.96621 6.72559 9.99973 6.72559C11.0332 6.72559 12.0668 6.78573 13.0936 6.91046C13.2183 7.9373 13.2785 8.97082 13.2785 10.0043L13.2786 10.0045Z"
                    fill="#BEBAB5"
                  />
                  <path
                    d="M19.5266 10.0737C19.5289 10.0604 19.5311 10.047 19.5333 10.0337C19.5311 10.047 19.5289 10.0626 19.5266 10.076C19.5244 10.0893 19.5222 10.1027 19.5222 10.1161C19.5177 10.1495 19.5133 10.1807 19.5088 10.2118C19.5133 10.1829 19.5155 10.1539 19.5177 10.125C19.4999 10.2141 19.4754 10.3032 19.4442 10.3878C19.3863 10.5103 19.315 10.6261 19.2371 10.7353C19.2081 10.7709 19.1792 10.8043 19.148 10.8377C19.0834 10.909 19.0143 10.9781 18.9453 11.0427C18.8718 11.1117 18.796 11.1763 18.7181 11.2387C18.7248 11.2342 18.7315 11.2298 18.7359 11.2253C18.7292 11.232 18.7203 11.2365 18.7136 11.2431H18.7114H18.7092C18.6936 11.2565 18.6691 11.2832 18.6513 11.2877C18.6468 11.2877 18.6646 11.2743 18.6869 11.2587C18.649 11.2877 18.6089 11.3144 18.5689 11.3434C18.3773 11.477 18.1768 11.5995 17.9697 11.7109C17.7358 11.8379 17.493 11.9537 17.248 12.0606C17.2747 12.0495 17.3037 12.0383 17.3304 12.0272L17.17 12.094C17.1923 12.0851 17.2146 12.0762 17.2368 12.065C16.3436 12.4326 15.4037 12.6865 14.457 12.8736C14.5038 12.4437 14.535 12.016 14.5617 11.5884C14.5929 11.0605 14.6063 10.5326 14.6063 10.0024V10.0047C14.6063 9.05135 14.5617 8.08911 14.457 7.13354C15.1587 7.27164 15.8536 7.44984 16.533 7.67924C16.7758 7.76166 17.0163 7.85075 17.2524 7.94876C17.2257 7.93762 17.199 7.92426 17.17 7.91312C17.2235 7.9354 17.2769 7.95767 17.3304 7.97994C17.3059 7.96881 17.2814 7.9599 17.2569 7.94876C17.6846 8.13364 18.1033 8.34747 18.4909 8.60809C18.5354 8.63705 18.58 8.66824 18.6245 8.69942C18.6468 8.71501 18.6669 8.7306 18.6891 8.74619C18.6914 8.74619 18.6914 8.74842 18.6936 8.74842C18.6758 8.73506 18.6624 8.72392 18.6602 8.72169C18.6624 8.72392 18.6735 8.73283 18.7025 8.7551C18.7159 8.76624 18.727 8.77292 18.7337 8.7796C18.7225 8.77069 18.7092 8.76178 18.698 8.75288C18.7225 8.77292 18.7493 8.7952 18.7626 8.80411C18.8027 8.83752 18.8428 8.87093 18.8829 8.90657C18.9564 8.97116 19.0255 9.04021 19.0945 9.11149C19.1524 9.17163 19.2037 9.24958 19.2638 9.3075C19.266 9.30972 19.2682 9.31418 19.2705 9.31641C19.2972 9.3565 19.3239 9.39437 19.3484 9.43669C19.3841 9.4946 19.4153 9.55474 19.4442 9.61711C19.4754 9.70398 19.5021 9.79085 19.5177 9.88217C19.5155 9.85321 19.5133 9.82426 19.5088 9.7953C19.5133 9.82871 19.5177 9.85989 19.5222 9.89108C19.5244 9.90445 19.5244 9.91558 19.5266 9.92895C19.5289 9.94454 19.5311 9.9579 19.5333 9.9735C19.5311 9.96013 19.5289 9.94677 19.5266 9.9334C19.5244 9.95568 19.5222 9.98018 19.5222 10.0047C19.5244 10.027 19.5244 10.0515 19.5266 10.0737L19.5266 10.0737Z"
                    fill="#BEBAB5"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>

        <div id="map" :key="partner.id">
          <GmapMap
            v-if="partner.geos.length > 0"
            :center="{ lat: partner.geos[0].latitude, lng: partner.geos[0].longitude }"
            :zoom="15"
            map-type-id="terrain"
            style="width: 100%; height: 100%"
            ref="mapRef"
            :options="{
              zoomControl: true,
              mapTypeControl: true,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false
            }"
          >
            <GmapMarker
              v-if="!!google"
              v-for="item in partner.geos"
              :position="{ lat: item.latitude, lng: item.longitude }"
              :draggable="false"
              :icon="{
                strokeColor: '#FFFFFF',
                strokeOpacity: 1,
                strokeWeight: 3,
                fillColor: '#00D9B2',
                fillOpacity: 1,
                path: google.maps.SymbolPath.CIRCLE,
                scale: 15,
                anchor: new google.maps.Point(0, 0)
              }"
            >
            </GmapMarker>
          </GmapMap>
        </div>

        <div class="sales" v-if="specials.length > 0 || specialsLoaded">
          <h2 v-if="specials.length > 0">{{ $t("partner.specials") }}</h2>

          <ul>
            <li
              v-for="item in specials"
              :key="item.id"
              @click="onSpecialClicked(item)"
            >
              <a class="js-modal-link">
                <div class="ico discount" v-if="item.type === 'sale'">
                  {{ item.sale + "%" }}
                </div>
                <div class="ico" v-else />
                <h3>{{ item.title }}</h3>
                <div class="karmitts">{{ item.cost }}</div>
              </a>
            </li>
          </ul>
        </div>
        <div
          class="sales"
          v-else-if="partner.title"
          style="text-align: center;"
        >
          <loading-progress
            :progress="0"
            :indeterminate="true"
            :counter-clockwise="false"
            :hide-background="false"
            shape="circle"
            :size="loadingIconSize"
          />
        </div>

        <div class="complain">
          <a @click="onComplaintClick">{{ $t("partner.report") }}</a>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import BackButton from "../components/layouts/BackButton";
import { mapActions, mapGetters } from "vuex";
import { gmapApi } from "gmap-vue";
import { eventBus } from "../main";
import imageSlider from "../assets/js/init/imageSlider";
import lightbox from "../assets/js/init/lightbox";
import { baseUrl } from "../appConfig.js";

export default {
  name: "Partner",
  components: { BackButton },
  data() {
    return {
      url: appSettings.baseUrl,
      loadingIconSize: null,
      partner: {
        id: this.$route.params.id,
        title: null,
        description: null,
        color: null,
        favorite: false,
        favoriteCount: 0,
        viewCount: 0,
        resourceId: null,
        resourceIds: [],
        logoResourceId: "",
        categoryName: null,
        goodsCategoryName: null,
        contacts: [],
        geo: {
          latitude: null,
          longitude: null
        },
        geos: []
      },
      specials: [],
      specialsLoaded: false,
      specialParams: {
        partnerId: this.$route.params.id
      }
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    google: gmapApi,
    hasVK() {
      return this.partner.contacts.find(c => c.type == "vk") !== undefined;
    },
    hasTG() {
      return (
        this.partner.contacts.find(c => c.type == "telegram") !== undefined
      );
    },
    hasEmail() {
      return this.partner.contacts.find(c => c.type == "email") !== undefined;
    },
    hasPhone() {
      return this.partner.contacts.find(c => c.type == "phone") !== undefined;
    },
    hasWeb() {
      return this.partner.contacts.find(c => c.type == "web") !== undefined;
    },
    getVK() {
        let val = this.partner.contacts.find(c => c.type == "vk").value;
        return !val.startsWith("http") ? "https://vk.com/" : '' + this.partner.contacts.find(c => c.type == "vk").value;
    },
    getTG() {
        let val = this.partner.contacts.find(c => c.type == "telegram").value;
        return !val.startsWith("http") ? "https://t.me/" : '' + this.partner.contacts.find(c => c.type == "telegram").value;
    },
    getEmail() {
      return "mailto:" + this.partner.contacts.find(c => c.type == "email").value;
    },
    getPhone() {
      return "tel:" + this.partner.contacts.find(c => c.type == "phone").value;
    },
    getWeb() {
      return this.partner.contacts.find(c => c.type == "web").value;
    }
  },
  async created() {
    this.setDefaultMapPosition();
    if (this.$route.params.item !== undefined) {
      this.mapper(this.$route.params.item);
    }
  },
  async mounted() {
    await this.getPartnerById({ id: this.$route.params.id }).then(result => {
      this.fillMeta(result.data);
      this.partner.title = result.data.title;
      this.$route.meta.title =
        this.$t("titles.default") + " — " + this.partner.title;

      this.partner.id = result.data.id;
      this.partner.description = result.data.description;
      this.partner.color = result.data.color;
      this.partner.favorite = result.data.favorite;
      this.partner.favoriteCount = result.data.favoriteCount;
      this.partner.viewCount = result.data.viewCount;
      this.partner.resourceId = result.data.resourceId;
      this.partner.logoResourceId = result.data.logoResourceId;
      this.partner.resourceIds = result.data.resourceIds;
      this.partner.contacts = result.data.contacts;
      if (result.data.category != null) {
        this.partner.categoryName = result.data.category.name;
      }
      if (result.data.goodsCategory != null) {
        this.partner.goodsCategoryName = result.data.goodsCategory.name;
      }
      if (result.data.geos.length > 0) {
        this.partner.geos.push(...result.data.geos);
        let geo = result.data.geos.filter(
          item => item.partnerPointId === this.$route.params.id
        )[0];
        if (geo) {
          this.partner.geo.longitude = geo.longitude;
          this.partner.geo.latitude = geo.latitude;
        }
      }
    });
    await this.loadSpecials({ partnerId: this.partner.id }).then(result => {
      this.specials.push(...result.data);
      this.specialsLoaded = true;
    });

    this.loaderIconInit();
    lightbox.init();
    imageSlider.init();
  },
  methods: {
    ...mapActions([
      "getPartnerById",
      "loadSpecials",
      "addToFavoriteSimplified"
    ]),

    createMetaTag(property, content) {
      const tmp = document.createElement("meta");
      tmp.setAttribute("property", property);
      tmp.setAttribute("content", content);
      document.head.appendChild(tmp);
    },

    fillMeta(dto) {
      document.head.querySelector("[property~=description]").remove();
      this.createMetaTag("og:title", "Karmitt - " + dto.title);
      this.createMetaTag("og:url", baseUrl);
      this.createMetaTag("og:description", dto.description);
      this.createMetaTag("description", dto.description);

      if (dto.resourceIds) {
        const img_url =
          appSettings.baseUrl + "api/client/resource/" + dto.logoResourceId;
        this.createMetaTag("og:image", img_url);
      }
    },

    createPartnerResourceUrl(id) {
      if (id) {
        return appSettings.baseUrl + "api/client/resource/" + id;
      } else {
        return this.previewLogo;
      }
    },
    createResourceUrl(id) {
      if (id) {
        return appSettings.baseUrl + "api/client/resource/" + id;
      } else {
        return null;
      }
    },
    addItemToFavorite() {
      let that = this;
      this.partner.favorite = !this.partner.favorite;
      this.addToFavoriteSimplified({
        id: this.partner.id,
        favorite: this.partner.favorite,
        type: "partners"
      }).catch(() => {
        that.partner.favorite = !that.partner.favorite;
      });
    },
    mapper(item) {
      this.partner.title = item.title;

      this.$route.meta.title = this.$t("titles.default") + " — " + item.title;

      this.partner.description = null; //item.description;
      this.partner.color = item.color;
      this.partner.favorite = item.favorite;
      this.partner.favoriteCount = item.favoriteCount;
      this.partner.viewCount = item.viewCount;
      this.partner.resourceId = item.favoriteResourceId;
      this.partner.categoryName = item.partnerCategory.name;
      this.partner.geo.latitude = item.geo.latitude;
      this.partner.geo.longitude = item.geo.longitude;
      this.partner.logoResourceId = item.logoResourceId;
      this.partner.contacts = item.contacts;

      if (item.resourceIds) {
        this.partner.resourceIds.splice(0, this.partner.resourceIds.length);
        this.partner.resourceIds.push(...item.resourceIds);
      } else {
        this.partner.resourceIds.push(item.favoriteResourceId);
      }

      this.partner.geos.push({
        latitude: item.geo.latitude,
        longitude: item.geo.longitude
      });
    },
    setDefaultMapPosition() {
      const stored = localStorage.getItem("currentLocation");
      if (stored) {
        const location = JSON.parse(stored);
        this.partner.geo.latitude = location.latitude;
        this.partner.geo.longitude = location.longitude;
      } else {
        this.partner.geo.latitude = 55.751244;
        this.partner.geo.longitude = 37.618423;
      }
    },
    onSpecialClicked(item) {
      if (this.isAuthenticated) {
        eventBus.$emit("showQrModal", item);
      } else {
        eventBus.$emit("onLoginModalOpen");
      }
    },
    onComplaintClick() {
      eventBus.$emit("onOpenComplaint", {
        goodsId: this.partner.id,
        chatId: null
      });
    },
    loaderIconInit() {
      let that = this;
      this.loadingIconSize = this.$refs.cont.clientWidth / 12;
      window.addEventListener("resize", function() {
        that.loadingIconSize = that.$refs.cont.clientWidth / 12;
      });
    }
  }
};
</script>

<style scoped></style>
